<template>
  <div class="home">
      <Slider />
      <Products />
      <SendForm/>
  </div>
</template>

<script>
import Slider from '@/components/Slider';
import Products from '@/components/Products';
import SendForm from '@/components/SendForm';

export default {
  name: 'Home',
  components: {
    Slider, Products, SendForm
  }
}
</script>
<style scoped lang="less">
.home {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    background: #fff;
    @media (max-width: 900px) {
        width: 95%;
    }
}
</style>